const gql = require("graphql-tag");

const ONE = gql`
  query ($data: ConfirmFindInput!) {
    Confirm(data: $data) {
      id
      company {
        id
        name
      }
      code
      dimensions
      product
      productPalace
      productNumber
      productDate
      serino
      controlNo
      description
      isActive
    }
  }
`;

const ALL = gql`
  query ($data: ConfirmFindInput) {
    Confirms(data: $data) {
      id
      company {
        id
        name
      }
      code
      dimensions
      product
      productPalace
      productNumber
      productDate
      serino
      controlNo
      description
      isActive
    }
  }
`;
const MANUEL_CONFIRM = gql`
  query ($data: ConfirmFindInput2) {
    ManuelConfirms(data: $data) {
      id
      dimensions
      product
      productDate
      productPalace
      serino
      createdAt
      queryLog {
        ip
        dimensions
        product
        productDate
        serino
        confirmCreatedAt
        createdAt
      }
    }
  }
`;

export const confirmQueries = {
  ONE,
  ALL,
  MANUEL_CONFIRM,
};
